import styled from "styled-components"
import InputFlagReventa from "./inputFlagReventa.jsx"



let Container=styled.div`
	display:flex;
	flex-direction:column;
	justify-content:space-between;
	width:80%
`;

let ContainerPrecios=styled.div`
	display:flex;
	justify-content:space-around
`;

export default function PricesReventa(props){
	let {reventa}=props;


	return(
		<Container>
 			<ContainerPrecios> 							
 				<InputFlagReventa codflag="pe" label="Peru" precio={reventa.precio_peru} />
 				<InputFlagReventa codflag="us" label="Dolar" precio={reventa.precio_resto} />
 				<InputFlagReventa codflag="ar" label="Argentina" precio={reventa.precio_argentina} />
 				<InputFlagReventa codflag="bo" label="Bolivia" precio={reventa.precio_bolivia} /> 							
 			</ContainerPrecios>
 			<ContainerPrecios>
 				<InputFlagReventa codflag="cl" label="Chile" precio={reventa.precio_chile} />
 				<InputFlagReventa codflag="co" label="Colombia" precio={reventa.precio_colombia} />
 				<InputFlagReventa codflag="mx" label="Mexico" precio={reventa.precio_mexico} />
 				<InputFlagReventa codflag="uy" label="Uruguay" precio={reventa.precio_uruguay} /> 
 			</ContainerPrecios>		
		</Container>
		)
}